/*
 * @Description: 心智占有率
 * @Author: yy
 * @Date: 2019-05-31 14:47:28
 * @LastEditors: yy
 * @LastEditTime: 2019-09-20 17:44:39
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './p22.css';

import ExportHeadTitle from '../../../components/ExportHeadTitle/ExportHeadTitle';
import ExportDes from '../../../components/ExportDes/ExportDes';
import ExportFootDes from '../../../components/ExportFootDes/ExportFootDes';
import ExportEcharts from '../../../components/ExportEcharts/ExportEcharts';

import {getShareOfMind} from '../../../controller';
import {shareOfMind} from '../../../chart';
import { getSessionQuery } from '../../../utils';
import moment from 'moment';

class P22 extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      query: {
        brandName: '',
        startDate: '',
        statisDate: ''
      },
      summary: {
        mind: '',
        brandName: '',
        industry: '',
        ranking: 0,
        mindCompare: ''
      },
      industry: '',
      chart: {}
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount () {
    this.getData();
    this.setState({
      industry:sessionStorage.getItem('industry')
    })
  }

  getQuery () {
    const query = getSessionQuery('query');

    const result = {
      brandName: query.brand,
      startDate: query.beginTime,
      statisDate: query.endTime
    }
    if (query.isCustom === '1') {
      result.areaIndustry = query.industry
      result.competingBrands = query.competingGoods.map(item => item.value).join(',')
    }
    return result
  }

  getData () {
    const query = this.getQuery();

    getShareOfMind(Object.assign({report: true}, query))
      .then(data => {
        this.setState({
          query: query,
          summary: data.chartsJson[0].highlight,
          chart: shareOfMind(data, query)
        })
      })
  }

  render() {
    const {query, summary} = this.state;
    let title = `心智占有率-表现与对比`
    if (this.state.industry !== 'undefined' && this.state.industry) {
      title = `心智占有率-${this.state.industry}行业表现与对比`
    }
    return (
      <div className={s.container}>
        <ExportHeadTitle>{title}</ExportHeadTitle>

        <div>
          <ExportDes> 
            本周报告期末（{moment(query.statisDate).format('M月D日')}），
            {query.brandName}在{summary.industry}行业内心智占有率为：{summary.mind}，
            较期初（{moment(query.startDate).format('M月D日')}）{summary.mindCompare}。
            位居行业第{summary.ranking}名。 
          </ExportDes>
        </div>

        <div className={s.echartWrapper}>
          <ExportEcharts option={this.state.chart}></ExportEcharts>
        </div>

        <ExportFootDes
          brandName={query.brandName}
          beginTime={query.startDate}
          endTime={query.statisDate}>
        </ExportFootDes>
      </div>
    );
  }
}

export default withStyles(s)(P22);



// WEBPACK FOOTER //
// src/routes/exportPDF/p22/p22.js